import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import GeoMark from "./GeoMark";
import { NAV_LINKS, COMPANY } from "../data/content";

const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#DCDDE0] text-coal">
    <div className="container-ax pt-20 sm:pt-28 pb-10">
      <div className="grid grid-cols-12 gap-y-14 lg:gap-x-8 pb-20 border-b border-ink/10">
        <div className="col-span-12 lg:col-span-4">
          <div className="flex items-center gap-3 mb-8">
            <GeoMark size={34} />
            <span className="leading-none">
              <span className="block text-[16px] font-bold tracking-[0.18em]">ARCH EXPO</span>
              <span className="block text-[8px] font-semibold tracking-[0.28em] mt-1 text-graphite">ARCHITECTURE · DESIGN · EXPO</span>
            </span>
          </div>
          <p className="text-graphite text-sm leading-relaxed max-w-xs">
            Integrated architecture, interior design, construction, procurement and project management — from concept to completion.
          </p>
        </div>
        <div className="col-span-6 sm:col-span-4 lg:col-span-2 lg:col-start-7">
          <p className="label-tech text-graphite/70 mb-6">Navigation</p>
          <ul className="space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} data-testid={`footer-nav-${l.label.toLowerCase()}`} className="link-line text-sm text-graphite hover:text-coal transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="col-span-6 sm:col-span-4 lg:col-span-2 lg:col-start-10">
          <p className="label-tech text-graphite/70 mb-6">Contact</p>
          <ul className="space-y-3 text-sm text-graphite">
            <li>
              <a href={`mailto:${COMPANY.email}`} data-testid="footer-email" className="link-line hover:text-coal transition-colors">{COMPANY.email}</a>
            </li>
            <li>
              <a href={COMPANY.linkedin} target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin" className="link-line inline-flex items-center gap-1 hover:text-coal transition-colors">
                LinkedIn <ArrowUpRight size={12} />
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="flex flex-wrap items-center justify-between gap-4 pt-8 pb-14 text-xs text-graphite/70">
        <span data-testid="footer-copyright">© {new Date().getFullYear()} Arch Expo AG. All rights reserved.</span>
        <div className="flex gap-8">
          <Link to="/legal" data-testid="footer-privacy-link" className="link-line hover:text-coal transition-colors">Privacy Policy</Link>
          <Link to="/legal" data-testid="footer-legal-link" className="link-line hover:text-coal transition-colors">Legal Notice</Link>
        </div>
      </div>
      <div className="overflow-hidden select-none" aria-hidden="true">
        <p className="text-[13.5vw] leading-[0.8] font-bold tracking-[-0.04em] text-ink/[0.05] whitespace-nowrap -mb-[2vw]">
          ARCH EXPO
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
